import Buttons from "../../components/Button/Button";
import { Grid, Typography } from "@mui/material";
import Logo from "../../assets/LAETUS.png";
const AdminHeader = () => {
  return (
    <Grid container alignItems='center'>
      <Grid md={12} container alignItems='center'>
        <Grid md={4}>
          <img src={Logo} alt='site logo' height={130} />
        </Grid>
        <Grid md={4} textAlign='center'>
          <Typography variant='h4' component='h1' sx={{ fontWeight: "bold" }}>
            Admin Dashboard
          </Typography>{" "}
        </Grid>
        <Grid md={4} textAlign='end'>
          <Buttons text='Logout' className='prev' />
        </Grid>
      </Grid>
    </Grid>
  );
};
export default AdminHeader;
